import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { PropertyViewComponent } from './component/property-view/property-view.component';
import { RentalObjectRentLossReportComponent } from './component/rental-object-rent-loss/rental-object-rent-loss.component';
import { ReportService } from './service/data/report.service';
import { CommonModule } from '../common/common.module';
import { MonthAnalysisAmountComponent } from './component/month-analysis-amount/month-analysis-amount.component';
import { RentRollComponent } from './component/rent-roll/rent-roll.component';
import { NotFullyPaidInvoiceComponent } from './component/not-fully-paid-invoice/not-fully-paid-invoice.component';
import { ReasonablenessControlComponent } from './component/reasonableness-control/reasonableness-control.component';
import { VatReportComponent } from './component/vat-report/vat-report.component';
import { StaircaseReportComponent } from './component/staircase-report/staircase-report.component';
import { MembershipListComponent } from './component/membership-list/membership-list.component';
import { VoluntaryTaxLiabilityComponent } from './component/voluntary-tax-liability/voluntary-tax-liability.component';
import { TaxReductionReportComponent } from './component/tax-reduction-report/tax-reduction-report.component';
import { AccountBalancePerInvoiceComponent } from './component/account-balance-per-invoice/account-balance-per-invoice.component';
import { HomepalDashboardsComponent } from './component/homepal-dashboards/homepal-dashboards.component';
import { InvoicedPerRentalObjectComponent } from './component/invoiced-per-rental-object/invoiced-per-rental-object.component';
import { BrfInnerFundPerRentalObjectComponent } from './component/brf-inner-fund/brf-inner-fund-per-rental-object.component';
import { CheckInAndCheckOutComponent } from './component/checkin-and-checkout/checkin-and-checkout.component';

@NgModule({
  imports: [CommonModule, CoreModule],
  declarations: [
    PropertyViewComponent,
    RentalObjectRentLossReportComponent,
    MonthAnalysisAmountComponent,
    InvoicedPerRentalObjectComponent,
    CheckInAndCheckOutComponent,
    AccountBalancePerInvoiceComponent,
    NotFullyPaidInvoiceComponent,
    RentRollComponent,
    ReasonablenessControlComponent,
    VatReportComponent,
    StaircaseReportComponent,
    TaxReductionReportComponent,
    MembershipListComponent,
    VoluntaryTaxLiabilityComponent,
    HomepalDashboardsComponent,
    BrfInnerFundPerRentalObjectComponent,
  ],
  providers: [ReportService],
})
export class ReportModule {}
